import { render, staticRenderFns } from "./BadgesByUser.vue?vue&type=template&id=2fbb240f"
import script from "./BadgesByUser.vue?vue&type=script&lang=js"
export * from "./BadgesByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports